<template>
  <FormSection
    v-model="inEditMode"
    :title="$t('ADVERTISEMENT.CAMPAIGN_VIEW.BASIC_INFO')"
    :description="$t('ADVERTISEMENT.CAMPAIGN_DETAILS.CAMPAIGN_DESC')"
    has-edit
  >
    <Card :hide-overflow="false">
      <CampaignInfoForm
        v-if="inEditMode"
        :data="campaignInfo"
        @cancel="exitEditMode"
        @update="updateCampaignInfo"
      />
      <CampaignInfoList v-else v-loading="isLoading" :data="campaignInfo" />
    </Card>
  </FormSection>
</template>

<script>
import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';
import CampaignInfoList from './CampaignInfoList';
import CampaignInfoForm from './CampaignInfoForm';
import layout from '@/mixins/layout';
import campaignId from '@/mixins/advertisement/campaignId';
import { BasicAdsCampaigns } from '@/api/api';

export default {
  name: 'CampaignInfo',

  components: {
    FormSection,
    Card,
    CampaignInfoList,
    CampaignInfoForm,
  },

  mixins: [layout, campaignId],

  data() {
    return {
      isLoading: true,
      campaignInfo: {
        name: '',
        budget: 0,
        spentBudget: 0,
        targetedCpi: 0,
        startDate: '',
        endDate: '',
        status: 'not_started',
        isPaused: false,
        installCount: 0,
        impressionTrackerLink: '',
        hasTracker: false,
        remainingBudget: 0,
      },
      inEditMode: false,
    };
  },

  mounted() {
    this.getCampaignInfo();
  },

  methods: {
    exitEditMode() {
      this.inEditMode = false;
    },

    updateCampaignInfo() {
      this.getCampaignInfo();
      this.$emit('update');

      this.exitEditMode();
    },

    getCampaignInfo() {
      this.isLoading = true;
      return BasicAdsCampaigns.getCampaignInfo(this.campaignId)
        .then(campaignInfo => {
          this.campaignInfo = campaignInfo;
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
